var columnChart = function(options, data, keys) {
	var self = this;
	this.data = data;
	this.keys = keys;
	this.container = options.container;
	this.margin = {top: 20, right: 20, bottom: 100, left: 50},
	this.width = 960,
	this.height = 500,
	this.setKeys = function(keys) {
		this.keys = keys;
	};
	this.setData = function(data) {
		this.data = data;
	}
	this.setDimensions = function() {
		if (typeof options.margin != "undefined") {
			self.margin = options.margin;
		}
		if (typeof options.width != "undefined") {
			self.width = options.width;
		}
		if (typeof options.height != "undefined") {
			self.height = options.height;
		}
	};
	this.removeChart = function() {
		d3.select("svg").remove();
	};
	this.buildChart = function() {
		d3.select("svg").remove();
		var margin = self.margin,
		    width = self.width - margin.left - margin.right,
		    height = self.height - margin.top - margin.bottom;

		var formatDate = d3.timeFormat("%B %e, %Y");

		// create the color scale to display graph series
        var color = d3.scaleOrdinal(d3.schemeCategory20);

        // append the svg obgect to the '#data-explorer-graph' div
      	// set width/height of svg object
      	var svg = d3.select(self.container).append("svg")
      		.attr("width", width + margin.left + margin.right)
      		.attr("height", height + margin.top + margin.bottom);

      	// appends a 'group' element to 'svg'
      	// moves the 'group' element to the top left margin
      	var g = svg.append("g")
        	.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

       	// create the x/y scales
		var x0 = d3.scaleBand().range([0, width]).paddingInner(0.1);
		var x1 = d3.scaleBand().padding(0.05);
		var y = d3.scaleLinear().range([height, 0]);

		// Scale the range of the data in the domains
		x0.domain(this.data.map(function(d) { return d.month; }));
		x1.domain(this.keys).rangeRound([0, x0.bandwidth()])
		y.domain([0, d3.max(this.data, function(d) { return d3.max(self.keys, function(key) { return d[key]; }); })]);

		// append rectangles
	 	g.append("g")
			.selectAll("g")
			.data(this.data)
			.enter().append("g")
					.attr("transform", function(d) { return "translate(" + x0(d.month) + ",0)"; })
			.selectAll("rect")
			.data(function(d) { return self.keys.map(function(key) { return {key: key, value: d[key]}; }); })
			.enter().append("rect")
					.attr("x", function(d) { return x1(d.key); })
					.attr("y", function(d) { return y(d.value); })
					.attr("width", x1.bandwidth())
					.attr("height", function(d) { return height - y(d.value); })
					.attr("fill", function(d) { return color(d.key); })
					.on("mouseover", function(d) { //define mouseover behavior
		        	d3.select(this) // increase dot size and stroke width on hover
		        		.style("opacity", 0.7)
		        		.style("stroke-width", 2)
		        		.style("stroke", "#000")
		       		/*div.transition() // tooltip animation
		         		.duration(100)
			         	.style("opacity", .9);
			        var t = d3.select(this.parentNode).attr("transform");
			         	t = t.substring(t.indexOf("(")+1, t.indexOf(")")).split(",");
			        // set tooltip text
		       		div.html("<div><md-icon class='material-icons md-24' style='margin-right: 5px;'>location_on</md-icon>" + d.key + "</div><div><md-icon class='material-icons md-24' style='margin-right: 5px;'>bubble_chart</md-icon>" + d.value + ' <em>' + series[0].result_unit_name +'</em></div>')
			         	.style("left", t[0] + "px") // set tooltip x placement
			         	.style("top", (d3.select(this).attr("y")+25) + "px");*/ // set tooltip y placement
		       	})
		     	.on("mouseout", function(d) { //define mouseout behavior
		     		d3.select(this) // reset dot style
		        		.style("opacity", 1)
		        		.style("stroke-width", 0)
		        		.style("stroke", "none")
		       		/*div.transition() // tooltip animation
		         		.duration(100)
		         		.style("opacity", 0);*/
		       	});
		g.append("g")
			.attr("class", "column-x-axis")
			.attr("transform", "translate(0," + height + ")")
			.call(d3.axisBottom(x0));

		g.append("g")
				.attr("class", "axis")
				.call(d3.axisLeft(y).ticks(null, "s").tickFormat(d3.format(",.0f")))
			.append("text")
	      		.attr("x", -100)
		      	.attr("y", 10)
		      	.attr("dy", "0.32em")
		      	.attr("fill", "#000")
		      	.attr("font-weight", "bold")
		      	.attr("text-anchor", "start")
		      	.attr("transform", "rotate(-90)")
		      	.text("Concentration ("+this.data[0].unit+")");

		// create graph legend
	    var legend = g.selectAll(".legend")
					.data(color.domain()) // relates to the domain of the ordinal cateogry color scale defined earlier
			.enter().append("g")
					.attr("class", "legend")
					.attr("transform", function(d, i) {return "translate(" + ((i * 55)) + ", " + (y(y.domain()[0]) + 50) + ")"; }); // legend placement

			// append colored rectangle that corresponds to series dot color
	    legend.append("rect")
      		.attr("x", 30)
	      	.attr("width", 25)
	      	.attr("height", 18)
	      	.style("fill", color);

	    // append legend text
	  	legend.append("text")
	      	.attr("x", 60)
	      	.attr("y", -9)
	      	.attr("dy", ".35em")
	      	.style("text-anchor", "end")
	      	.text(function(d) { return d; });

	};
	this.init = (function() {
		self.setDimensions();
		self.buildChart();
	})();
}
